export default __webpack_public_path__ + "static/media/WHO-5.cd056f2f.pdf";